<template>
  <div>
    <div class="card card-outline">
      <div class="card-body">
        <div class="row">

          <div class="col-md-12 mb-3">
            <div class="input-xs-full-width w-50 mb-3">
              <label for="select-element" class="mb-2">Select UI element</label>
              <select @change="gradientElementPreview($event)" v-model="selectedElement" id="select-element"
                      class="form-select form-control form-big-height"
                      aria-label="Select element">
                <option value="Buttons" selected>Buttons</option>
                <option value="Card">Card</option>
                <option value="Text">Text</option>
              </select>
            </div>
          </div>

          <div class="col-md-12 mb-3" id="sectionButtons">
            <!-- BUTTON -->
            <div class="subtitle-1 mb-2">Button</div>
            <div v-if="gradient.color3">
              <button class="btn p-3"
                      :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }">
                {{ gradient.name }}
              </button>
              <button class="btn btn-round"
                      :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }">
                <i class="material-icons-outlined">add</i>
              </button>
              <div class="d-grid">
                <button class="btn p-3"
                        :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }">
                  {{ gradient.name }} - full width
                </button>
              </div>
            </div>
            <div v-else>
              <button class="btn p-3"
                      :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ')' }">
                {{ gradient.name }}
              </button>
              <button class="btn btn-round"
                      :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ')' }">
                <i class="material-icons-outlined">add</i>
              </button>
              <div class="d-grid">
                <button class="btn p-3"
                        :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ')' }">
                  {{ gradient.name }} - full width
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-12 d-none" id="sectionCard">
            <!-- CARD -->
            <div class="subtitle-1 mb-2">Card</div>
            <div class="card" v-if="gradient.color3"
                 :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }">
              <div class="card-body">
                <h6 class="fw-500 mb-3">{{ gradient.name }}</h6>
                <div class="subtitle-1 fw-500 mb-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod
                  tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                  ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </div>
                <button class="btn">Action</button>
                <button class="btn">Primary action</button>
              </div>
            </div>
            <div class="card" v-else
                 :style="{ 'background': 'linear-gradient' + '(' + '135deg' + ',' + gradient.color1 + ',' + gradient.color2 + ')' }">
              <div class="card-body">
                <p class="fw-500 typography-headline-sm mb-3">{{ gradient.name }}</p>
                <div class="subtitle-1 fw-500 mb-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod
                  tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                  ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </div>
                <button class="btn">Action</button>
                <button class="btn">Primary action</button>
              </div>
            </div>
          </div>

          <div class="col-md-12 d-none" id="sectionText">
            <!-- TEXT -->
            <div class="subtitle-1 mb-2">Text</div>
            <h2 class="fw-500 text-gradient" v-if="gradient.color3"
                :style="{ 'background-image': 'linear-gradient' + '(' + 'to top' + ',' + gradient.color1 + ',' + gradient.color2 +  ',' + gradient.color3 + ')' }">
              {{ gradient.name }}</h2>
            <h2 class="fw-500 text-gradient" v-else
                :style="{ 'background-image': 'linear-gradient' + '(' + 'to top' + ',' + gradient.color1 + ',' + gradient.color2 + ')' }">
              {{ gradient.name }}</h2>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElementsPreviewGradient',
  props: [
    'gradient'
  ],
  data() {
    return {
      selectedElement: 'Buttons',
    }
  },
  methods: {
    gradientElementPreview() {
      const element = this.selectedElement
      if (element === 'Buttons') {
        document.getElementById('sectionText').className = 'd-none'
        document.getElementById('sectionCard').className = 'd-none'
        document.getElementById('sectionButtons').className = ''
        document.getElementById('sectionButtons').classList.toggle('d-block')
      }
      if (element === 'Card') {
        document.getElementById('sectionButtons').className = 'd-none'
        document.getElementById('sectionText').className = 'd-none'
        document.getElementById('sectionCard').className = ''
        document.getElementById('sectionCard').classList.toggle('d-block')
      }
      if (element === 'Text') {
        document.getElementById('sectionButtons').className = 'd-none'
        document.getElementById('sectionCard').className = 'd-none'
        document.getElementById('sectionText').className = ''
        document.getElementById('sectionText').classList.toggle('d-block')
      }
    }
  }
}
</script>